import React, { PropsWithChildren, useEffect } from "react";
import { useRouter } from "next/router";
import Modal from "ui/Modal/Modal";
import Button from "ui/Button/Button";
import { cn } from "helpers/style";
import styles from "./MobileTooltip.module.scss";

type Props = {
  onClose: () => void;
  withoutOKButton?: boolean;
};

const MobileTooltip: React.FC<PropsWithChildren<Props>> = ({
  children,
  onClose,
  withoutOKButton,
}: PropsWithChildren<Props>) => {
  const router = useRouter();

  useEffect(() => {
    router.events.on("routeChangeStart", onClose);

    () => {
      router.events.off("routeChangeStart", onClose);
    };
  }, [router.events, onClose]);

  return (
    <div className={styles.tooltip}>
      <Modal className={styles.tooltipModalContainer} onClose={onClose}>
        <div
          className={cn([
            styles.tooltipInner,
            withoutOKButton && styles.tooltipInnerWithoutMargin,
          ])}
        >
          {children}
        </div>

        {!withoutOKButton && (
          <Button onClick={onClose} fluid small gray>
            OK
          </Button>
        )}
      </Modal>
    </div>
  );
};

export default MobileTooltip;
